import apple from "../../../images/category/organicApple.jpg";
import cream from "../../../images/category/organicCream.jpg";
import kokat from "../../../images/category/organicKokat.jpg";
import qulupnay from "../../../images/category/organicQulupnay.jpg";
import organicDonlar from "../../../images/category/organicDonlar.jpg";
import organicPamidor from "../../../images/category/organicPamidor.jpg";
import organictut from "../../../images/category/organictut.jpg";
import organicTuhum from "../../../images/category/organicTuhum.jpg";
import organickalbasa from "../../../images/category/organickalbasa.jpg";
import organicHamir from "../../../images/category/organicHamir.jpg";

let category = [
  {
    id: 1,
    category_name: "Milks & Creams",
    img: apple,
  },
  {
    id: 2,
    category_name: "Fruits",
    img: cream,
  },
  {
    id: 3,
    category_name: "Vegetables",
    img: kokat,
  },
  {
    id: 4,
    category_name: "Nut gifts",
    img: qulupnay,
  },
  {
    id: 5,
    category_name: "Nut & Seeds",
    img: organicDonlar,
  },
  {
    id: 6,
    category_name: "Fresh Tomatoes",
    img: organicPamidor,
  },
  {
    id: 7,
    category_name: "Fresh Organic",
    img: organictut,
  },
  {
    id: 8,
    category_name: "Butter & Aggs",
    img: organicTuhum,
  },
  {
    id: 9,
    category_name: "Fresh Meats",
    img: organickalbasa,
  },
  {
    id: 10,
    category_name: "Trees",
    img: organicHamir,
  },
];

export default category;